import { useQuery } from "@tanstack/react-query";
import { cmsService } from "@/services/cmsService";
import { bannersService } from "@/services/bannersService";
import type { BannerFilterParams } from "@/types/banner.dto";
import { BannerType } from "@/types/banner.dto";
import { queryKeys } from "./keys";

export function useCmsPageBySlug(slug: string, enabled = true) {
  return useQuery({
    queryKey: queryKeys.cms.page(slug),
    queryFn: () => cmsService.getBySlug(slug),
    enabled: enabled && slug.length > 0,
    retry: false,
  });
}

export function useHomeBanners(filter: BannerFilterParams = { type: BannerType.Home, activeOnly: true, pageSize: 10 }) {
  return useQuery({
    queryKey: queryKeys.banners.list(filter),
    queryFn: () => bannersService.getAll(filter),
  });
}
